import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface RetreatStyle {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRetreatStyleData {
  name: string;
  status: 'active' | 'inactive';
}

const retreatStyleService = {
  async getActiveRetreatStyles(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<PaginatedResponse<RetreatStyle>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    
    const response = await api.get(`/retreat-style/active?${queryParams.toString()}`);
    return response.data;
  },

  async createRetreatStyle(styleData: CreateRetreatStyleData): Promise<ApiResponse<RetreatStyle>> {
    const response = await api.post('/retreat-style', styleData);
    return response.data;
  }
};

export default retreatStyleService;
